import { PriceDeviationResponse } from '@/types/menus.types';
import { BundleUpchargePriceDeviationResponse } from './bundleUpchargePriceDeviation.types';

/**
 * Maps bundle upcharge price deviation API response to the shared PriceDeviationResponse[] shape
 * so the shared PriceDeviationsDrawerShared and PriceDeviationsTable can be used.
 */
export function mapBundleUpchargeToPriceDeviationResponse(
  data: BundleUpchargePriceDeviationResponse | undefined | null,
): PriceDeviationResponse[] {
  if (!data || typeof data !== 'object') return [];
  return [
    {
      productName: data.description ?? '',
      productDescription: '',
      variantId: '',
      majorityPricePoint: data.majorityPricePoint ?? null,
      priceDeviations: data.priceDeviations ?? [],
      isLock: data.isLock ?? false,
    },
  ];
}
